// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__84I4I","card":"Cards_card__3pDWq","infected":"Cards_infected__udxoN","recovered":"Cards_recovered__3ULAc","deaths":"Cards_deaths__2Ht5p"};